import { render, staticRenderFns } from "./Tareas.vue?vue&type=template&id=30c96a36&scoped=true"
import script from "./Tareas.vue?vue&type=script&lang=js"
export * from "./Tareas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c96a36",
  null
  
)

export default component.exports